import React from 'react'
import './Groups.css'
import { ControlText, ControlTextArea, ControlNumber, ControlSwitch, ControlSelect } from './Controls'

const GroupText = (props) => (
  <div className={props.error ? 'group group--err row' : 'group row'}>
    <div className='col-sm-2'>
      <label>{props.label}</label>
    </div>
    <div className='col-sm-10'>
      <ControlText
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        lg={props.lg}
        error={props.error}
      />
    </div>
  </div>
)

const GroupTextArea = (props) => (
  <div className={props.error ? 'group group--err row' : 'group row'}>
    <div className='col-sm-2'>
      <label>{props.label}</label>
    </div>
    <div className='col-sm-10'>
      <ControlTextArea
        rows={props.rows}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        error={props.error}
      />
    </div>
  </div>
)

const GroupNumber = (props) => (
  <div className={props.error ? 'group group--err row' : 'group row'}>
    <div className='col-sm-2'>
      <label>{props.label}</label>
    </div>
    <div className='col-sm-10'>
      <ControlNumber
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        lg={props.lg}
        error={props.error}
      />
    </div>
  </div>
)

const GroupSwitch = (props) => (
  <div className='group row'>
    <div className='col-sm-2'>
      <label>{props.label}</label>
    </div>
    <div className='col-sm-10'>
      <ControlSwitch
        value={props.value}
        onChange={props.onChange}
      />
    </div>
  </div>
)

const GroupCustom = (props) => (
  <div className={props.error ? 'group group--err row' : 'group row'}>
    <div className='col-sm-2'>
      <label>{props.label}</label>
    </div>
    <div className='col-sm-10'>
      {props.children}
    </div>
  </div>
)

const GroupSelect = (props) => (
  <div className={props.error ? 'group group--err row' : 'group row'}>
    <div className='col-sm-2'>
      <label>{props.label}</label>
    </div>
    <div className='col-sm-10'>
      <ControlSelect
        value={props.value}
        placeholder={props.placeholder}
        options={props.options}
        onChange={props.onChange}
      />
    </div>
  </div>
)

export { GroupText, GroupTextArea, GroupNumber, GroupCustom, GroupSwitch, GroupSelect }
